/**
 * Interactor (Business Logic) for Story Section
 * Handles business logic for the genesis story
 */
export const useStoryInteractor = () => {
  const getStoryContent = () => {
    return {
      title: "Pourquoi Bookiner est né",
      paragraphs: [
        "Trop souvent, de bons livres finissent oubliés.\nIls restent sur une étagère, alors qu'ils pourraient encore circuler, être lus, et trouver un nouveau propriétaire.",
        "En cherchant à acheter ou revendre des livres, un constat s'impose rapidement :\nles plateformes existantes sont généralistes. Elles facilitent les transactions, mais sont rarement pensées spécifiquement pour les livres et pour la manière dont on les découvre.",
        "Bookiner est né de cette observation simple :\nil manquait une marketplace dédiée aux livres, claire, accessible, et conçue autour de leurs usages réels.\nUne plateforme où l'achat et la revente sont simples, mais où la découverte a aussi sa place.",
        "Bookiner commence comme une marketplace.\nMais l'ambition va plus loin : permettre aux livres de continuer leur parcours, et aux utilisateurs de trouver plus facilement ce qu'ils cherchent (ou ce qu'ils ne cherchaient pas encore)."
      ],
    };
  };

  const handleFollowProject = () => {
    // Scroll to early access section
    const earlyAccessSection = document.querySelector('.early-access');
    if (earlyAccessSection) {
      earlyAccessSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return {
    story: getStoryContent(),
    onFollowProject: handleFollowProject,
  };
};
